import {Preview, template as tpl} from "./Preview";
import userHtml from './user.html?raw';

export let template = tpl.replace('<!-- {{TEMPLATE_ROW}} -->', userHtml);

export class viewModel extends Preview {

    constructor(params: any) {
        super(params);
        this.table = [
            {
                key: "id",
                sort: false
            },
            {
                key: "GivenName",
                sort: true
            },
            {
                key: "Surname",
                sort: true
            },
            {
                key: "Department",
                sort: true
            },
            {
                key: "username",
                sort: false
            }
        ];
        this.searchcolumn("GivenName");
    }

}
